<p>To associate SOR codes with Visit Types, please use the SOR Code Admin screen.</p>
<button mat-flat-button [routerLink]="'/setup/codes/sor'" mat-dialog-close>SOR Code Admin</button>
